import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { trackPromise } from "react-promise-tracker";
import { toast } from "react-toastify";
import api from "../../constants/api";
import suppliesApi from "../../constants/suppliesApi";

const HistoryModal = ({ open, hidde, odometer }) => {
  const [data, setData] = useState([]);
  const [observation, setObservation] = useState("");

  useEffect(() => {
    getHistory(odometer.id);
  }, []);

  const getHistory = (id) => {
    trackPromise(
      suppliesApi
        .getHistoryByOdometer(id)
        .then((res) => {
          setData(res);
        })
        .catch((err) => {
          toast.error(err.response.data.detail);
        })
    );
  };

  const restoreOdometer = (e) => {
    e.preventDefault();
    const str = "?placa=" + odometer.vehicle;
    if (window.confirm("¿ Estas seguro de reiniciar el odometro ?")) {
      trackPromise(
        api
          .getAllVehicles(localStorage.getItem("GlobalCustomerId"), str)
          .then((res) => {
            if (res.vehicles[0]) {
              trackPromise(
                suppliesApi
                  .restoreOdometer(odometer.id, {
                    current_km: res.vehicles[0].fuel_km_info.kilometers,
                    observation: observation,
                  })
                  .then((res) => {
                    toast.success("Odometro reiniciado");
                    hidde();
                  })
                  .catch((err) => {
                    toast.error(err.toString());
                  })
              );
            }
          })
          .catch((err) => {
            toast.error(err.toString());
          })
      );
    }
  };

  return (
    <Modal show={open} dialogClassName="modal-sm-providers" onHide={hidde}>
      <Modal.Header closeButton>
        <Modal.Title>Historial de odometro: {odometer.code}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {data.length > 0 ? (
          <div className="text-center v-scroll my-3">
            <table className="table table-striped table-bordered table-sm mb-0">
              <thead>
                <tr>
                  <th scope="col">Kilometros</th>
                  <th scope="col">Observacion</th>
                  <th scope="col">Fecha de reinicio</th>
                </tr>
              </thead>
              <tbody>
                {data.map((hs) => (
                  <tr key={hs.id}>
                    <td className="p-2">{hs.current_km}</td>
                    <td className="p-2">{hs.observation}</td>
                    <td className="p-2">
                      {moment
                        .utc(hs.created_at)
                        .local()
                        .locale("es")
                        .format("LLL")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-center my-4">
            Odometro {odometer.code} sin historial
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="w-100">
          {odometer.vehicle ? (
            <form onSubmit={(e) => restoreOdometer(e)}>
              <div className="form-group">
                <div className="row">
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      placeholder="*Agrega una observacion"
                      id="nameInput"
                      value={observation}
                      onChange={(e) => setObservation(e.target.value)}
                      required
                    />
                  </div>
                  <button
                    className="btn btn-primary col-md-4"
                    disabled={observation.length ? false : true}
                  >
                    Reiniciar Odometro
                  </button>
                </div>
              </div>
            </form>
          ) : (
            <p>Para reiniciar el odometro, debe estar montado en un vehiculo</p>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default HistoryModal;
